import React from 'react';
import '../styles/LogoAnimation.css'; // Asegúrate que la ruta sea correcta

const AnimatedLogo = () => {
  return (
    <div className="logo-container">
      
      {/* CAPA INFERIOR: El fondo de imagen y las burbujas */}
      <div className="bubble-background">
        
        {/* Elementos individuales para las burbujas */}
        <div className="bubble x1"></div>
        <div className="bubble x2"></div>
        <div className="bubble x3"></div>
        <div className="bubble x4"></div>
        <div className="bubble x5"></div>
        <div className="bubble x6"></div>
        {/* Si quieres más, simplemente añade más divs aquí (.bubble xN) */}
      </div>

      {/* CAPA SUPERIOR: El logo morado */}
      <div className="logo-image">
        {/* ¡IMPORTANTE! Asegúrate de reemplazar esta ruta con la de tu logo. */}
        <img 
          src="media/logo-abis-lp.png" 
          alt="Logo de la Empresa" 
        />
      </div>
    </div>
  );
};

export default AnimatedLogo;